import client from './client';
import type { RefSupplier, RefColor, RefBrand, RefSupplyLookup } from '@/types/api';

export const referenceDataApi = {
  // Suppliers
  getSuppliers: async (): Promise<RefSupplier[]> => {
    const response = await client.get('/reference-data/suppliers');
    return response.data;
  },
  
  createSupplier: async (data: { name: string; websiteUrl?: string; sortOrder?: number }): Promise<RefSupplier> => {
    const response = await client.post('/reference-data/suppliers', data);
    return response.data;
  },
  
  updateSupplier: async (id: string, data: { name: string; websiteUrl?: string; sortOrder?: number }): Promise<RefSupplier> => {
    const response = await client.put(`/reference-data/suppliers/${id}`, data);
    return response.data;
  },
  
  deleteSupplier: async (id: string): Promise<void> => {
    await client.delete(`/reference-data/suppliers/${id}`);
  },

  // Colors
  getColors: async (): Promise<RefColor[]> => {
    const response = await client.get('/reference-data/colors');
    return response.data;
  },
  
  createColor: async (data: { name: string; hexCode: string; sortOrder?: number }): Promise<RefColor> => {
    const response = await client.post('/reference-data/colors', data);
    return response.data;
  },
  
  updateColor: async (id: string, data: { name: string; hexCode: string; sortOrder?: number }): Promise<RefColor> => {
    const response = await client.put(`/reference-data/colors/${id}`, data);
    return response.data;
  },
  
  deleteColor: async (id: string): Promise<void> => {
    await client.delete(`/reference-data/colors/${id}`);
  },

  // Brands
  getBrands: async (): Promise<RefBrand[]> => {
    const response = await client.get('/reference-data/brands');
    return response.data;
  },
  
  createBrand: async (data: { name: string }): Promise<RefBrand> => {
    const response = await client.post('/reference-data/brands', data);
    return response.data;
  },
  
  updateBrand: async (id: string, data: { name: string }): Promise<RefBrand> => {
    const response = await client.put(`/reference-data/brands/${id}`, data);
    return response.data;
  },
  
  deleteBrand: async (id: string): Promise<void> => {
    await client.delete(`/reference-data/brands/${id}`);
  },

  // Supply lookup lists
  getSupplyLookups: async (params?: { category?: string; parentValue?: string }): Promise<RefSupplyLookup[]> => {
    const response = await client.get('/reference-data/supply-lookups', { params });
    return response.data;
  },

  createSupplyLookup: async (data: {
    category: string;
    value?: string;
    label: string;
    parentValue?: string;
    metadataJson?: string;
    sortOrder?: number;
  }): Promise<RefSupplyLookup> => {
    const response = await client.post('/reference-data/supply-lookups', data);
    return response.data;
  },

  updateSupplyLookup: async (id: string, data: {
    category: string;
    value?: string;
    label: string;
    parentValue?: string;
    metadataJson?: string;
    sortOrder?: number;
  }): Promise<RefSupplyLookup> => {
    const response = await client.put(`/reference-data/supply-lookups/${id}`, data);
    return response.data;
  },

  deleteSupplyLookup: async (id: string): Promise<void> => {
    await client.delete(`/reference-data/supply-lookups/${id}`);
  },
};
